// extracted by mini-css-extract-plugin
module.exports = {"DisclaimerPage":"disclaimerPage_DisclaimerPage__2zHtu","wrapper":"disclaimerPage_wrapper__3cbuc","title":"disclaimerPage_title__6qGz3","text":"disclaimerPage_text__4_xYn"};